<template>
  <div>
    <!-- Modals -->
    <CreditGroupAddModal
      id="addCreditGroupModal"
      :clientId="clientId || 0"
      @ok="getCreditGroupsOfClient"
    ></CreditGroupAddModal>

    <CreditGroupEditModal
      id="editCreditGroupModal"
      :creditGroup="selectedCreditGroup"
      @ok="getCreditGroupsOfClient"
    />
    
    <!-- Credit Groups -->
    <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50 mb-3">
      <template v-slot:header>
        <h6
          class="m-0 font-weight-bold"
        >Credit Groups -  {{ creditGroupList ? creditGroupList.length : 0  }}</h6>
      </template>

      <!-- CreditGroups -->
      <b-card-text>
        <b-card-group class="children-mr-2 mb-2">
          <b-button
            v-if="!restrictedMode"
            v-b-modal.addCreditGroupModal
            variant="primary"
            size="sm"
            class="bg-site-primary"
          >Add Credit Group</b-button>
        </b-card-group>
      </b-card-text>
      <b-card-text>
        <b-table
          hover
          sticky-header
          :items="creditGroupList"
          @row-clicked="editCreditGroup"
          primary-key="id"
          tbody-tr-class="cursor-pointer"
          :fields="[
            {
              key: 'id',
              label: 'ID',
              sortable: true
            },
            {
              key: 'name',
              label: 'Name',
              sortable: true
            },
            {
              key: 'credits',
              label: 'Credits',
              sortable: true
            },
            {
              key: 'exams',
              label: 'Exams',
            },
          ]"
        >
          <template v-slot:cell(exams)="data">
            <ol v-if="data && data.item && Array.isArray(data.item.exams)">
              <li v-for="exam in data.item.exams" :key="exam.name">
                <span v-if="restrictedMode">
                  {{ removeHtml(exam.shortName) }}
                </span>
                <span v-else>
                  {{exam.name}}
                </span>
              </li>
            </ol>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    
  </div>
</template>

<script>
import CreditGroupAddModal from "./CreditGroupAddModal";
import CreditGroupEditModal from "./CreditGroupEditModal";

export default {
  components: {
    CreditGroupAddModal,
    CreditGroupEditModal,
  },
  data() {
    return {
      selectedCreditGroup: null,
      creditGroupList : []
    }
  },
  props: {
    clientId: String,
    restrictedMode: Boolean,
  },
  mounted () {
    this.getCreditGroupsOfClient();
  },
  methods: {
    getCreditGroupsOfClient() {
      const clientId = this.clientId;
      if (!clientId || isNaN(clientId)) {
        this.$router.push("../");
      } else {
        this.$store
          .dispatch("creditGroup/getAllOfClient", { clientId })
          .then((data) => (this.creditGroupList = data.data));
      }
    },
    editCreditGroup(creditGroup){
      if(!this.restrictedMode){
        this.selectedCreditGroup = creditGroup
        this.$bvModal.show('editCreditGroupModal')

      }
    },
    removeHtml(str){
      return str.replace( /(<([^>]+)>)/ig, ' ')
    }

  },
};
</script>

<style lang="scss" scoped>
</style>